import common from './common';
import privateReport from './privateReport';
import acente from './acente';
import antrepoStok from './antrepoStok';

export const TRANSLATIONS_TR = {
  ...common,
  ...privateReport,
  ...acente,
  ...antrepoStok,
};
